import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import {
  Observable,
  Subscription,
  fromEvent
} from 'rxjs';

import { CommonService } from 'src/app/services/common/common.service';
import { LoaderService } from 'src/app/components/loader/loader.service';
import { MessagingService } from './services/messaging/messaging.service';
import { PushNotificationModel } from './models/push.notifications.model';
import { Router } from '@angular/router';
import { StateManagerService } from './services/state-manage/state-manager.service';
import { Token } from './services/token';
import { UserSessionService } from './services/user-session/user-session.service';
import { delay, filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent implements OnInit, OnDestroy {
  consoleMessage: string = "This feature is intended for developers only ";
  consoleStyle: string = "color: #900968; font-size: 28px;font-weight: bold;";
  public showAddToHomeScreen: boolean = false;
  notificationData: PushNotificationModel;
  countReload = 1;
  showNotificationPopup: boolean = false;
  loader = false;
  notificationInterval: any;
  public deferredPrompt: any;
  public geoLocation: any;
  showFooter: boolean = true;

  subscription: Subscription = new Subscription();
  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;
  subscriptions: Subscription[] = [];

  connectionStatusMessage: string;
  connectionStatus: string;

  /**
   * @description
   * handle push showing of push notification popup when a room is active
   */
  chatRoomId: string;
  showChatNotification: boolean = true;

  chatCount: number = 0;
  constructor(
    private $loader: LoaderService,
    private $cdk: ChangeDetectorRef,
    private $messagingService: MessagingService,
    private $common: CommonService,
    private $router: Router,
    private $stateManage: StateManagerService,
    private $token: Token,
    private $userSession: UserSessionService
  ) {
    console.log(`%c${this.consoleMessage}`, this.consoleStyle);
    // this.geoLocation =  this.$storageService.handleUsersGeolocation();
  }

  ngOnInit() {
    this.getUserCurrentLocation();
    this.chechStatus();
    this.subscription.add(
      this.$common.ShowFooter.pipe(delay(0)).subscribe(data => {
        this.showFooter = data;
      })
    )
    // this.listenRouterEvents();gfr
    this.getNotification();
    this.handlePushNotificationOnChat();
    this.listenPageVisibilityForSessionEnd();
  }

  /**
   * When app goes to background, end user session for engagement metrics (optional).
   */
  private listenPageVisibilityForSessionEnd(): void {
    const visibility$ = fromEvent(document, 'visibilitychange');
    this.subscription.add(
      visibility$.pipe(
        filter(() => document.visibilityState === 'hidden' && this.$token.hasValue)
      ).subscribe(() => {
        this.$userSession.endSession().subscribe();
      })
    );
  }

  handlePushNotificationOnChat() {
    this.subscription.add(
      this.$common.pushOnChat$.pipe(delay(0)).subscribe(data => {
        this.chatRoomId = data;
      })
    )
  }




  getUserCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const params = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        }
        this.$common.setDataInLocalStorage('location', params);
        this.$stateManage.locationObject = params;
        this.$stateManage.location$.next(true)
        // this.$stateManage.locationAccess = true;
      }, (err) => {
        this.$stateManage.location$.next(false)
        // this.$stateManage.locationAccess = false;
      })

    }
  }

  /**
   * @ONLINE_OFFLINE Get the online/offline status from browser window
   */
  chechStatus() {
    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');
    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Back to online';
      this.connectionStatus = 'online';

    }));

    this.subscriptions.push(this.offlineEvent.subscribe(e => {

      this.connectionStatusMessage = 'Connection lost! You are not connected to Internet';
      this.$loader.hide();
      this.connectionStatus = 'offline';
    }));
  }


  closeNotificationPopup() {
    this.showNotificationPopup = false;
    clearTimeout(this.notificationInterval);
    this.$cdk.detectChanges();
  }
  getNotification() {
    this.$messagingService.requestPermission()
      .catch(() => {
        // Permission denied or blocked – ignore to prevent unhandled rejection
      });
    this.$messagingService.receiveMessage();
    this.$messagingService.listenNotifications();
    this.subscriptions.push(this.$messagingService.currentMessage.subscribe((res: any) => {
      if (this.$router.url.includes('/chat')) {
        this.chatCount = -1;
      }
      if (res.data.roomId) {
        this.$stateManage.chatNotificationCount$.next({ flag: true, isChatPage: false, count: ++this.chatCount, countUpdate: true })
      } else {
        this.$stateManage.chatNotificationCount$.next({ flag: false, isChatPage: false, countUpdate: false });
      }
      if (!this.chatRoomId) {
        this.showChatNotification = false;
        this.$stateManage.notificationCount$.next({ flag: true, isChatPush: true })
      }
      else if (this.chatRoomId !== res.data.roomId) {
        this.showChatNotification = false;
        this.$stateManage.notificationCount$.next({ flag: true, isChatPush: true })
      } else {
        this.showChatNotification = true;
      }
      this.notificationData = res.data;
      this.showPopUp();
    }));
  }

  navigateToNotificationDetails() {
    this.$stateManage.handleNavigationViaPush(this.notificationData, false);
  }
  private showPopUp() {
    if (this.showNotificationPopup) {
      clearTimeout(this.notificationInterval);
      this.showNotificationPopup = false;
      this.$cdk.detectChanges();
      setTimeout(() => {
        this.showNotificationPopup = true;
        this.$cdk.detectChanges();
      }, 2000);
    } else {
      this.showNotificationPopup = true;
    }
    this.$cdk.detectChanges();
    this.notificationInterval = setTimeout(() => {
      this.showNotificationPopup = false;
      this.$cdk.detectChanges();
    }, 2000);
  }





  /**
   * @UNSUBSCRIPTION Unsubscribe all subscriptions to avoid memory leak
   */
  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }


}


